"use strict";

const AUTO_CLOSE_REDIPLUS = false;

module.exports = /* @ngInject */ function(
  $log,
  $q,
  openFinApi,
  eikonSessionMonitor,
  eikonSsoService,
  sideBySideApi,
  eikonUsageCheck
) {
  var that = this;
  this.start = function() {
    eikonUsageCheck.canHaveEikonSession().then(function(canHaveEikonSession) {
      if (canHaveEikonSession) {
        watchEikonSession();
      }
    });
  };

  function watchEikonSession() {
    eikonSessionMonitor
      .resolveWhenExistingSessionIsInvalidated()
      .then(function() {
        eikonUsageCheck
          .maybePromptUserToRelogin()
          .then(function(maybePromptUserToRelogin) {
            if (maybePromptUserToRelogin) {
              $log.info("Publishing ESO event to R+");
              openFinApi.publish("eso-event", {});
            } else {
              $log.info("Stopping Eikon session. R+ will not be shutdown.");
              that.stop(false);
            }
          });
      });
  }

  this.stop = function(preserveEikonSession) {
    return eikonUsageCheck
      .canHaveEikonSession()
      .then(function(canHaveEikonSession) {
        if (canHaveEikonSession) {
          return reallyStop(preserveEikonSession);
        }
      });
  };

  function reallyStop(preserveEikonSession) {
    return sideBySideApi.shutdownEikonLight().finally(function() {
      return eikonSsoService.handleEikonSessionIsInvalidated().then(() => {
        return endAll(preserveEikonSession);
      });
    });
  }

  function endAll(preserveEikonSession) {
    eikonSessionMonitor.stop();
    if (preserveEikonSession) {
      return;
    }
    return eikonSsoService.endEikonSession();
  }
};



// WEBPACK FOOTER //
// ./app/business/rediPlusLifeCycleManager.js